/**
 * @generated SignedSource<<74f5e9e98ceace44d2a9daca4b2abd30>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type issueTotalCount_softwareReleasesVersionDetailIssueList$data = {
  readonly allIssuesRedesignTemp: {
    readonly totalCount: number;
  };
  readonly " $fragmentType": "issueTotalCount_softwareReleasesVersionDetailIssueList";
};
export type issueTotalCount_softwareReleasesVersionDetailIssueList$key = {
  readonly " $data"?: issueTotalCount_softwareReleasesVersionDetailIssueList$data;
  readonly " $fragmentSpreads": FragmentRefs<"issueTotalCount_softwareReleasesVersionDetailIssueList">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "issueTotalCount_softwareReleasesVersionDetailIssueList",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "alias": "allIssuesRedesignTemp",
        "concreteType": "JiraIssueConnection",
        "kind": "LinkedField",
        "name": "issues",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "kind": "ScalarField",
              "name": "totalCount"
            },
            "action": "THROW",
            "path": "allIssuesRedesignTemp.totalCount"
          }
        ]
      },
      "action": "THROW",
      "path": "allIssuesRedesignTemp"
    }
  ],
  "type": "JiraVersion"
};

(node as any).hash = "aaf1e03a6deba9e0e365569571ef5db3";

export default node;
